
  import IconBase from './IconBase.vue';

  export default {
    name: 'IconX',
    components: { IconBase },
  };
